module.exports = __webpack_public_path__ + "static/media/video-cover.5bb4fa25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video-cover.jpg
// module id = 663
// module chunks = 0